import Vue from "vue";

let els;

if ((els = document.querySelectorAll(".cities-selector")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el: el,
      name: "CitiesSelector",
      data() {
        return {
          cities: [],
          citiesSelect: [],
          opened: false,
          city: false,
        };
      },
      methods: {
        travelToCity(city) {
          if (this.city != false) {
            window.location = city || this.city;
            localStorage.setItem("city", city || this.city);
          } else {
            this.city = false;
            localStorage.setItem("city", false);
            window.location = "/";
          }
        },
      },
      created() {
        this.cities = window.passdata.citiesSelect;
      },
      beforeMount() {
        if (this.$el.getAttr("currentCity")) {
          this.city = this.$el.getAttr("currentCity");
        } else {
          if (
            localStorage.getItem("city") &&
            localStorage.getItem("city") != null
          ) {
            this.city = localStorage.getItem("city");
          } else {
            this.city = false;
          }
        }
        localStorage.setItem("city", this.city);
        if (window.passdata.city_slug) {
          this.currentCity = _.find(
            this.cities,
            (city, index) => city.slug === window.passdata.city_slug
          );
          localStorage.setItem("city", this.currentCity.url);
        }
      },
    });
  }
}
